export default __webpack_public_path__ + "7551cd70e3f03b1fda6a7d22d5076b4d.png";